module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.tolast
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("秒杀专场")])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary countdown-bar"
  }, [(_vm.secFlag === 0) ? _c('span', {
    staticClass: "link",
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [_vm._v("抢购即将开始，敬请期待")]) : (_vm.secFlag === 1) ? _c('span', {
    staticClass: "link",
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [(_vm.secInfo.limitNumber > 0) ? _c('span', [_vm._v("已售" + _vm._s(_vm.secInfo.usedNumber) + "单")]) : _c('span', [_vm._v("抢购中")])]) : _c('span', {
    staticStyle: {
      "color": "#FFFFFF",
      "background": "#666",
      "border-radius": "3px",
      "padding": "2px 3px"
    }
  }, [_vm._v("秒杀结束")]), _vm._v(" "), _c('span', {
    staticClass: "link countdown",
    staticStyle: {
      "float": "right"
    }
  }, [_c('Countdown', {
    attrs: {
      "startDT": _vm.secInfo.startDT,
      "endDT": _vm.secInfo.endDT
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card facebook-card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [(_vm.openLink()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/nrxuBV",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl,
      "width": "100%"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl,
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('newMerchandiseListA', {
    attrs: {
      "merch-list": _vm.merchandise,
      "description": _vm.$route.query.des,
      "channel": _vm.$route.params.channel
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-856d4496","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Promotion/SecPromotion.vue
// module id = 1689
// module chunks = 8